import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "common/utils";

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery,
  tagTypes: [
    "Company",
    "Inquiry",
    "Transaction",
    "Product",
    "Quest",
    "Xp",
    "Badge",
    "QuestManagement",
    "Ranking",
  ],
  endpoints: () => ({}),
});
